import styled from 'styled-components';
import textStyle from './text-style';

export default styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-family: ${({ theme }) => theme.standoutFontFamily};
  text-transform: uppercase;
  ${textStyle}
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    font-size: 2rem;
  }
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    font-size: 3.333rem;
  }
`;
